// src/hooks/productTypes/useRestoreAllProductTypes.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllProductTypes as restoreAllProductTypesAPI } from "../../api/apiProductTypes";
import parseError from "../../utils/parseError";

const useRestoreAllProductTypes = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAll, isPending: isRestoreAll } = useMutation({
        mutationFn: restoreAllProductTypesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Product types restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["productTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore product types");
        },
    });

    return { restoreAllProductTypes: restoreAll, isRestoreAll };
};

export default useRestoreAllProductTypes;